import React from 'react'
import {Link} from 'react-router-dom'
import { useLanguage } from '../../contexts/LanguageContext';
import sarzoParkBg from '../../images/sarzo_park.webp';

const CtaSection2 = (props) => {
    const { t } = useLanguage();
    const ClickHandler = () => {
        window.scrollTo(10, 0);
      }
    return(
        <>
            <style>
                {`
                    .wpo-cta-section-s3 {
                        width: 100vw !important;
                        margin-left: calc(50% - 50vw) !important;
                        margin-right: calc(50% - 50vw) !important;
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    .wpo-cta-section-s3 .wpo-cta-item h2 {
                        font-size: 55px !important;
                    }
                    @media (max-width: 991px) {
                        .wpo-cta-section-s3 .wpo-cta-item h2 {
                            font-size: 44px !important;
                        }
                    }
                    @media (max-width: 767px) {
                        .wpo-cta-section-s3 .wpo-cta-item h2 {
                            font-size: 32px !important;
                        }
                    }
                    @media (max-width: 480px) {
                        .wpo-cta-section-s3 .wpo-cta-item h2 {
                            font-size: 28px !important;
                        }
                    }
                `}
            </style>
            <div id="location" className="wpo-cta-section-s3" style={{ 
                backgroundImage: `url(${sarzoParkBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat'
            }}>
                <div className="conatiner-fluid">
                    <div className="wpo-cta-item">
                        <h2>{t('cta.title')}</h2>
                        <p>{t('cta.description')}</p>
                        <a href="https://www.google.com/maps/place/S%C3%A1rz%C3%B3-Park/@47.4642339,17.2889471,646m/data=!3m2!1e3!4b1!4m6!3m5!1s0x476be33a958f1ef3:0x6dcefb53f3f24561!8m2!3d47.4642303!4d17.291522!16s%2Fg%2F11vt8v2x7y?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" className="theme-btn-s2">{t('cta.viewDetails')}</a>
                    </div>
                </div>
            </div>
        </>

    )
}

export default CtaSection2;